<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!taxGroup">
      <span class="loader"></span>
    </span>
    <tax-group-form
      v-if="taxGroup"
      :loading="loading"
      :taxGroupData="taxGroup"
      :formErrors="formErrors"
      :only-taxes="onlyTaxes"
      @taxGroupSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
      @cancelEdition="cancelEdition"
    />
  </div>
</template>

<script>
import TaxGroupForm from "../partials/TaxGroupForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { TaxGroupForm },

  mixins: [alertLeave],

  props: {
    taxGroupId: {
      type: [String, Number],
      required: true,
    },
    onlyTaxes: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      taxGroup: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    cancelEdition() {
      this.$emit("cancelEdition");
    },
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("taxGroups/get", this.taxGroupId);
        this.taxGroup = this.$store.getters["taxGroups/taxGroup"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(taxGroup) {
      this.loading = true;
      const taxGroupData = cloneDeep(taxGroup);

      try {
        await this.$store.dispatch("taxGroups/update", taxGroupData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAX_GROUP_UPDATED"),
        });
        const taxGroup = await this.$store.getters["taxGroups/taxGroup"];
        this.$emit("onViewTaxGroup", taxGroup, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
